import React from 'react';

const EnergyConserved = () => {
  return (
    <div className="key-statics">
      <div className="first-title">
        <h5>2.40 million GJ</h5>
        <p>of energy conserved (target: 1.75 million GJ)</p>
      </div>
      <h5>₹288 crore</h5>
      <p>Community investment: (FY2019: ₹291 crore)</p>
    </div>
  );
};

export default EnergyConserved;
